import React, { useEffect, useState, useRef } from "react"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"
import { getGillieList, getVideoRoomList } from "helpers/backend_helper"
import { Select, ConfigProvider } from "antd"
import { Col, Row } from "reactstrap"
const { Option } = Select;

const SelectGillie = props => {
  const [options, setOptions] = useState([])
  const [loading, setLoading] = useState(false)

  const abortRef = useRef(null)
  useEffect(() => {
    abortRef.current = new AbortController()
    getData()
    return () => abortRef.current.abort()
  }, [])

  // Get entries for dropdown
  const getData = () => {
    setLoading(true)
    getGillieList(abortRef.current).then(result => {
      let opts = result.entries ?? []
      setOptions(opts)
    })
      .catch(e => {
        console.log(e)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  // Selection changed
  const handleChange = newSelection => {
    if (props.onChange != null) {
      props.onChange(newSelection)
    }
  }

  // Custom empty/Data not found dropdown
  const customizeRenderEmpty = () => (
    <div className="mt-3" style={{ textAlign: "center" }}>
      {loading
        ? <p>{props.t("Loading")}</p>
        : <p>{props.t("No entries found")}</p>
      }
    </div>
  )

  return (
    <>
      <ConfigProvider renderEmpty={customizeRenderEmpty}>
        <div className="config-provider">
          <Select
            loading={loading}
            disabled={props.disabled}
            value={props.selection}
            allowClear={props.clearable == null ? true : props.clearable}
            placeholder={props.placeholder ? props.t(props.placeholder) : props.t("Select")}
            style={{ width: 100 + "%" }}
            onChange={handleChange}
            options={options}
          />
        </div>
      </ConfigProvider>
    </>
  )
}

SelectGillie.propTypes = {
  t: PropTypes.any,
  selection: PropTypes.string,
  onChange: PropTypes.func,
  clearable: PropTypes.bool,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
}

export default withTranslation()(SelectGillie)